export const carLoanData = [
  {
    id: 1,
    heading:
      "Car Loan Balance Transfer with MinEMI: Drive Your Savings Further",
    subHeading:
      "See how much you could save by transferring debt from a high-interest loan or credit card to a more favorable loan.",
    notice:
      "Many, or all, of the products featured on this page are from our advertising partners who compensate us when you take certain actions on our website or click to take an action on their website. However, this does not influence our evaluations. Our opinions are our own. Here is a list of our partners and here's how we make money.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
